<template>
  <div>
    <!-- 标题 -->
    <div class="rds-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.databaseId }}</BreadcrumbItem>
        <BreadcrumbItem to="/monitor/relationalDatabaseServiceMonitor">{{
          $t("alarms.database.database")
        }}</BreadcrumbItem>
        <BreadcrumbItem>
          <a @click="ipAddress">{{ $t("alarms.common.monitoringSummary") }}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 查询框 -->
    <div class="rds-top">
      <Row :gutter="16">
        <Col span="6" v-show="isAWS">
          <Select v-model="timeType" @on-change="changeTimeType(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col span="6" v-show="isAWS">
          <Select v-model="cycle" @on-change="changeCycle()">
            <Option
              v-for="item in cycleList"
              :value="item.value"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
        <Col span="6" v-show="isALY">
          <Select v-model="timeType" @on-change="changeTimeTypeALY(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col span="6" v-show="isALY">
          <Select v-model="cycle" @on-change="changeCycleAliyun()">
            <Option
              v-for="item in cycleList"
              :value="item.value"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
        <Col span="6" v-show="isAzureMySQL">
          <Select
            v-model="timeType"
            @on-change="changeTimeTypeAzureMySQL(timeType)"
          >
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col span="6" v-show="isAzureSQLServer">
          <Select
            v-model="timeType"
            @on-change="changeTimeTypeAzureSqlServer(timeType)"
          >
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col span="6" v-show="isGCP">
          <Select v-model="timeType" @on-change="changeTimeTypeGCP(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col span="6" v-show="isGCP">
          <Select v-model="cycle" @on-change="changeCycleGCP()">
            <Option
              v-for="item in cycleList"
              :value="item.value"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </Row>
    </div>
    <!-- 折线图 -->
    <Row :gutter="16">
      <Col
        span="6"
        v-for="(item, index) in this.$route.query.accountTypeName == 'AWS'
          ? awsList
          : this.$route.query.accountTypeName == 'Azure' &&
            this.$route.query.engine.indexOf('mysql') != -1
          ? azureMySQLList
          : this.$route.query.accountTypeName == 'Azure' &&
            this.$route.query.engine.indexOf('SQL Server') != -1
          ? azureSQLServerList
          : this.$route.query.accountTypeName == 'GCP'
          ? gcpList
          : alyList"
        :key="index"
      >
        <Card :padding="8">
          <p slot="title">{{ item.title }}</p>
          <a href="#" slot="extra" @click.prevent="changeFull(item)">
            <Icon type="ios-expand" size="18" />
          </a>
          <div
            :id="item.id"
            :ref="item.id"
            style="width: 100%; height: 240px"
          ></div>
        </Card>
      </Col>
    </Row>
    <!-- 放大弹出框 -->
    <Modal
      v-model="isShowModal"
      :mask-closable="false"
      :closable="false"
      width="65%"
    >
      <Row>
        <Col span="24">
          <h3>{{ lineTitle }}</h3>
          <div
            id="chart-part"
            ref="fullChart"
            style="width: 100%; height: 420px"
          ></div>
        </Col>
      </Row>
      <div slot="footer">
        <div>
          <Button @click="cancel">{{ $t("alarms.common.close") }}</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
export default {
  name: "RDS",
  data() {
    return {
      // 放大功能
      lineTitle: "",
      isShowModal: false,
      // aws折线图
      awsList: [
        {
          id: "cpu",
          title: this.$t("alarms.database.line.CPUUtilizationPercent"),
        },
        {
          id: "databaseConnections",
          title: this.$t(
            "alarms.database.line.NumberOfDatabaseConnectionsNumber"
          ),
        },
        {
          id: "cpucreditBalance",
          title: this.$t(
            "alarms.database.line.CpucreditBalance"
          ),
        },
        {
          id: "cpucreditUsage",
          title: this.$t(
            "alarms.database.line.CpucreditUsage"
          ),
        },
        {
          id: "ebsbyteBalance",
          title: this.$t(
            "alarms.database.line.EbsbyteBalance"
          ),
        },
        {
          id: "ebsiobalance",
          title: this.$t(
            "alarms.database.line.EbsioBalance"
          ),
        },
        {
          id: "bufferCacheHitRatio",
          title: this.$t(
            "alarms.database.line.BufferCacheHitRatio"
          ),
        },
        {
          id: "writeReadLatency",
          title: this.$t("alarms.database.line.WriteReadLatency"),
        },
        {
          id: "networkReceiveTransmitThrough",
          title: this.$t("alarms.database.line.NetworkReceiveTransmitThrough"),
        },
        {
          id: "freeStorage",
          title: this.$t("alarms.database.line.AvailableStorageSpaceBytes"),
        },
        {
          id: "availableMemory",
          title: this.$t("alarms.database.line.AvailableMemoryMB"),
        },
        {
          id: "writeReadIOPS",
          title: this.$t("alarms.database.line.ReadAndWriteIOPSTimesSecond"),
        },
        {
          id: "queueDepth",
          title: this.$t("alarms.database.line.QueueDepthNumber"),
        },
        {
          id: "binaryLogDiskUsage",
          title: this.$t("alarms.database.line.BinaryLogDiskUsageMB"),
        },
        {
          id: "writeReadThroughput",
          title: this.$t("alarms.database.line.ReadAndWriteThroughputMBSec"),
        },
        {
          id: "rdsReplicaLag",
          title: this.$t("alarms.database.line.rdsReplicaLag"),
        },
      ],
      // 阿里云折线图
      alyList: [
        {
          id: "cpus",
          title: this.$t("alarms.database.line.CPUUsagePercentage"),
        },
        {
          id: "connectionUsages",
          title: this.$t("alarms.database.line.ConnectionUsagePercentage"),
        },
        {
          id: "memory",
          title: this.$t("alarms.database.line.MemoryUsagePercentage"),
        },
        {
          id: "disk",
          title: this.$t("alarms.database.line.DiskUsagePercentage"),
        },
        {
          id: "writeReadIOPSs",
          title: this.$t("alarms.database.line.IOPSUsageRatePercentage"),
        },
        {
          id: "networkInput",
          title: this.$t("alarms.database.line.NetworkInputBits"),
        },
        {
          id: "networkOut",
          title: this.$t("alarms.database.line.NetworkOutBits"),
        },
        {
          id: "pgActiveConnections",
          title: this.$t("alarms.database.line.PgActiveConnections"),
        },
        {
          id: "pgBlksReadDelta",
          title: this.$t("alarms.database.line.PgBlksReadDelta"),
        },
        {
          id: "pgConnUsage",
          title: this.$t("alarms.database.line.PgConnUsage"),
        },
        {
          id: "pgCpuTotal",
          title: this.$t("alarms.database.line.PgCpuTotal"),
        },
        {
          id: "pgDbAge",
          title: this.$t("alarms.database.line.PgDbAge"),
        },
        {
          id: "pgMemUsage",
          title: this.$t("alarms.database.line.PgMemUsage"),
        },
        {
          id: "pgPlsDataSize",
          title: this.$t("alarms.database.line.PgPlsDataSize"),
        },
        {
          id: "pgPlsIops",
          title: this.$t("alarms.database.line.PgPlsIops"),
        },
        {
          id: "pgPlsIopsRead",
          title: this.$t("alarms.database.line.PgPlsIopsRead"),
        },
        {
          id: "pgPlsIopsWrite",
          title: this.$t("alarms.database.line.PgPlsIopsWrite"),
        },
        {
          id: "pgPlsPgWalDirSize",
          title: this.$t("alarms.database.line.PgPlsPgWalDirSize"),
        },
        {
          id: "pgPlsThroughput",
          title: this.$t("alarms.database.line.PgPlsThroughput"),
        },
        {
          id: "pgPlsThroughputRead",
          title: this.$t("alarms.database.line.PgPlsThroughputRead"),
        },
        {
          id: "pgPlsThroughputWrite",
          title: this.$t("alarms.database.line.PgPlsThroughputWrite"),
        },
        {
          id: "pgRollbackRatio",
          title: this.$t("alarms.database.line.PgRollbackRatio"),
        },
        {
          id: "pgSwellTime",
          title: this.$t("alarms.database.line.PgSwellTime"),
        },
        {
          id: "pgTps",
          title: this.$t("alarms.database.line.PgTps"),
        },
      ],
      // azureMySQL折线图
      azureMySQLList: [
        {
          id: "cpuPercentMySQL",
          title: this.$t("alarms.database.line.CPUUsagePercentage"),
        },
        {
          id: "storagePercentMySQL",
          title: this.$t("alarms.database.line.StorageUtilizationPercentage"),
        },
        {
          id: "memoryPercentMySQL",
          title: this.$t("alarms.database.line.MemoryUtilizationPercentage"),
        },
        {
          id: "activeConnectionsMySQL",
          title: this.$t("alarms.database.line.ActiveConnectionsCount"),
        },
        {
          id: "ioConsumptionPercentMySQL",
          title: this.$t("alarms.database.line.IOUtilizationPercentage"),
        },
      ],
      // azureSQLServer折线图
      azureSQLServerList: [
        {
          id: "cpuPercentSQLServer",
          title: this.$t("alarms.database.line.CPUUtilizationPercent"),
        },
        {
          id: "storagePercentSQLServer",
          title: this.$t("alarms.database.line.StorageUtilizationPercentage"),
        },
        {
          id: "sqlserverProcessMemoryPercentSQLServer",
          title: this.$t(
            "alarms.database.line.ProcessMemoryPercentagePercentage"
          ),
        },
        {
          id: "connectionSuccessfulSQLServer",
          title: this.$t(
            "alarms.database.line.NumberOfSuccessfulConnectionsCount"
          ),
        },
      ],
      //gcp折线图
      gcpList: [
        {
          id: "sqlDiskReadOPS",
          title: this.$t("alarms.database.line.SqlDiskReadOPSCount"),
        },
        {
          id: "sqlDiskWriteOPS",
          title: this.$t("alarms.database.line.SqlDiskWriteOPSCount"),
        },
        {
          id: "sqlCpuUsage",
          title: this.$t("alarms.database.line.SqlCpuUsageS"),
        },
        {
          id: "sqlCpuUtilization",
          title: this.$t("alarms.database.line.SqlCpuUtilizationPercentage"),
        },
        {
          id: "diskUtilization",
          title: this.$t("alarms.database.line.DiskUtilizationPercentage"),
        },
        {
          id: "sqlMemoryUtilization",
          title: this.$t("alarms.database.line.SqlMemoryUtilizationPercentage"),
        },
        {
          id: "sqlReceivedBytes",
          title: this.$t("alarms.database.line.SqlReceivedBytesByte"),
        },
        {
          id: "networkConnections",
          title: this.$t("alarms.database.line.NetworkConnectionsCount"),
        },
        {
          id: "innodbPagesTotal",
          title: this.$t("alarms.database.line.InnodbPagesTotal"),
        },
        {
          id: "memoryTotalUsage",
          title: this.$t("alarms.database.line.MemoryTotalUsageInnoDBMb"),
        },
      ],
      AliyunList: [],
      isAWS: false,
      isALY: false,
      isGCP: false,
      isAzureMySQL: false,
      isAzureSQLServer: false,
      timeType: 0,
      timeList: [],
      accountTypeName: "",
      accountName: "",
      product: "",
      // echarts实例
      chart: "",
      chartDatabaseConnections: "",
      chartCpucreditBalance:"",
      chartCpucreditUsage:"",
      chartEbsbyteBalance:"",
      chartEbsiobalance:"",
      chartNetworkReceiveThroughput:"",
      chartNetworkTransmitThroughput:"",
      chartReadLatency:"",
      chartWriteLatency:"",
      chartBufferCacheHitRatio:"",
      chartWriteReadLatency:"",
      chartNetworkReceiveTransmitThrough:"",
      chartFreeStorage: "",
      chartAvailableMemory: "",
      chartWriteReadIOPS: "",
      chartQueueDepth: "",
      chartBinaryLogDiskUsage: "",
      chartWriteReadThroughput: "",
      chartRdsReplicaLag: "",
      chartDisk: "",
      chartMemory: "",
      chartCPU: "",
      chartConnectionUsages: "",
      chartNetworkInput: "",
      chartNetworkOut: "",
      chartPgActiveConnections: "",
      chartPgBlksReadDelta: "",
      chartPgConnUsage: "",
      chartPgCpuTotal: "",
      chartPgDbAge: "",
      chartPgMemUsage: "",
      chartPgPlsDataSize: "",
      chartPgPlsIops: "",
      chartPgPlsIopsRead: "",
      chartPgPlsIopsWrite: "",
      chartPgPlsPgWalDirSize: "",
      chartPgPlsThroughput: "",
      chartPgPlsThroughputRead: "",
      chartPgPlsThroughputWrite: "",
      chartPgRollbackRatio: "",
      chartPgSwellTime: "",
      chartPgTps: "",
      chartSqlDiskReadOPS: "",
      chartSqlDiskWriteOPS: "",
      chartSqlCpuUsage: "",
      chartSqlCpuUtilization: "",
      chartDiskUtilization: "",
      chartSqlMemoryUtilization: "",
      chartSqlReceivedBytes: "",
      chartNetworkConnections: "",
      chartMemoryTotalUsage: "",
      chartInnodbPagesTotal: "",
      cpuOption: {},
      databaseConnectionsOption: {},
      cpucreditBalanceOption:{},
      cpucreditUsageOption:{},
      ebsbyteBalanceOption:{},
      ebsiobalanceOption:{},
      networkReceiveThroughputOption:{},
      networkTransmitThroughputOption:{},
      readLatencyOption:{},
      writeLatencyOption:{},
      bufferCacheHitRatioOption:{},
      freeStorageOption: {},
      availableMemoryOption: {},
      writeReadIOPSOption: {},
      writeReadLatencyOption:{},
      networkReceiveTransmitThroughOption:{},
      queueDepthOption: {},
      binaryLogDiskUsageOption: {},
      writeReadThroughputOption: {}, //aws
      rdsReplicaLagOption: {},
      cpusOption: {},
      connectionUsagesOption: {},
      memoryOption: {},
      diskOption: {},
      writeReadIOPSsOption: {},
      networkInputOption: {},
      networkOutOption: {},
      pgActiveConnectionsOption: {},
      pgBlksReadDeltaOption: {},
      pgConnUsageOption: {},
      pgCpuTotalOption: {},
      pgDbAgeOption: {},
      pgMemUsageOption: {},
      pgPlsDataSizeOption: {},
      pgPlsIopsOption: {},
      pgPlsIopsReadOption: {},
      pgPlsIopsWriteOption: {},
      pgPlsPgWalDirSizeOption: {},
      pgPlsThroughputOption: {},
      pgPlsThroughputReadOption: {},
      pgPlsThroughputWriteOption: {},
      pgRollbackRatioOption: {},
      pgSwellTimeOption: {},
      pgTpsOption: {}, //阿里云
      cpuPercentMySQLOption: {},
      storagePercentMySQLOption: {},
      memoryPercentMySQLOption: {},
      activeConnectionsMySQLOption: {},
      ioConsumptionPercentMySQLOption: {}, //azureMySQL
      cpuPercentSQLServerOption: {},
      storagePercentSQLServerOption: {},
      sqlserverProcessMemoryPercentSQLServerOption: {},
      connectionSuccessfulSQLServerOption: {}, //azureSQLServer
      sqlDiskReadOPSOption: {},
      sqlDiskWriteOPSOption: {},
      sqlCpuUsageOption: {},
      sqlCpuUtilizationOption: {},
      diskUtilizationOption: {},
      sqlMemoryUtilizationOption: {},
      sqlReceivedBytesOption: {},
      networkConnectionsOption: {},
      memoryTotalUsageOption: {},
      innodbPagesTotalOption: {}, //gcp
      // 数组
      rdscpu: [],
      databaseConnections: [],
      cpucreditBalance:[],
      cpucreditUsage:[],
      ebsbyteBalance:[],
      ebsiobalance:[],
      networkReceiveThroughput:[],
      networkTransmitThroughput:[],
      readLatency:[],
      writeLatency:[],
      bufferCacheHitRatio:[],
      diskQueueDepth: [],
      rdsdiskMonitorNative: [],
      rdsramMonitorNative: [],
      rdsreadWriteIOPS: [],
      rdswriteIOPS: [],
      readThroughput: [],
      writeThroughput: [],
      xaxisData: [],
      rdsReplicaLag: [],
      cpuUsage: [],
      memoryUsage: [],
      diskUsage: [],
      iopsUsage: [],
      azureCpuPercent: [], //Azure
      pgActiveConnections: [],
      pgBlksReadDelta: [],
      pgConnUsage: [],
      pgCpuTotal: [],
      pgDbAge: [],
      pgMemUsage: [],
      pgPlsDataSize: [],
      pgPlsIops: [],
      pgPlsIopsRead: [],
      pgPlsIopsWrite: [],
      pgPlsPgWalDirSize: [],
      pgPlsThroughput: [],
      pgPlsThroughputRead: [],
      pgPlsThroughputWrite: [],
      pgRollbackRatio: [],
      pgSwellTime: [],
      pgTps: [],
      azureStoragePercent: [],
      azureMemoryPercent: [],
      azureActiveConnections: [],
      azureIoConsumptionPercent: [],
      azureXaxisData: [],
      azureCpuPercentSqlServer: [],
      azureStoragePercentSqlServer: [],
      azureSqlserverProcessMemoryPercentSqlServer: [],
      azureConnectionSuccessfulSqlServer: [],
      azureXaxisDataSqlServer: [],
      cycle: 300,
      cycleList: [
        {
          name: this.$t("alarms.common.fiveMinutes"),
          value: 5 * 60,
        },
        {
          name: this.$t("alarms.common.fifteenMinutes"),
          value: 15 * 60,
        },
        {
          name: this.$t("alarms.common.oneHour"),
          value: 1 * 60 * 60,
        },
        {
          name: this.$t("alarms.common.sixHour"),
          value: 6 * 60 * 60,
        },
        {
          name: this.$t("alarms.common.oneDay"),
          value: 24 * 60 * 60,
        },
      ],
    };
  },
  mounted: function () {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chart.resize();
        self.chartDatabaseConnections.resize();
        self.chartFreeStorage.resize();
        self.chartCpucreditBalance.resize();
        self.chartCpucreditUsage.resize();
        self.chartEbsbyteBalance.resize();
        self.chartEbsiobalance.resize();
        self.chartBufferCacheHitRatio.resize();
        self.chartAvailableMemory.resize();
        self.chartWriteReadIOPS.resize();
        self.chartWriteReadLatency.resize();
        self.chartNetworkReceiveTransmitThrough.resize();
        self.chartQueueDepth.resize();
        self.chartBinaryLogDiskUsage.resize();
        self.chartWriteReadThroughput.resize();
        self.chartRdsReplicaLag.resize();
      });
    } else if (this.$route.query.accountTypeName == "Aliyun") {
      this.isALY = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartCPU.resize();
        self.chartConnectionUsages.resize();
        self.chartMemory.resize();
        self.chartDisk.resize();
        self.chartWriteReadIOPS.resize();
        self.chartNetworkInput.resize();
        self.chartNetworkOut.resize();
        self.chartPgActiveConnections.resize();
        self.chartPgBlksReadDelta.resize();
        self.chartPgConnUsage.resize();
        self.chartPgCpuTotal.resize();
        self.chartPgDbAge.resize();
        self.chartPgMemUsage.resize();
        self.chartPgPlsDataSize.resize();
        self.chartPgPlsIops.resize();
        self.chartPgPlsIopsRead.resize();
        self.chartPgPlsIopsWrite.resize();
        self.chartPgPlsPgWalDirSize.resize();
        self.chartPgPlsThroughput.resize();
        self.chartPgPlsThroughputRead.resize();
        self.chartPgPlsThroughputWrite.resize();
        self.chartPgRollbackRatio.resize();
        self.chartPgSwellTime.resize();
        self.chartPgTps.resize();
      });
    } else if (
      this.$route.query.accountTypeName == "Azure" &&
      this.$route.query.engine.indexOf("mysql") != -1
    ) {
      this.isAzureMySQL = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartCpuPercentMySQL.resize();
        self.chartStoragePercentMySQL.resize();
        self.chartMemoryPercentMySQL.resize();
        self.chartActiveConnectionsMySQL.resize();
        self.chartIoConsumptionPercentMySQL.resize();
      });
    } else if (
      this.$route.query.accountTypeName == "Azure" &&
      this.$route.query.engine.indexOf("SQL Server") != -1
    ) {
      this.isAzureSQLServer = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartCpuPercentSQLServer.resize();
        self.chartStoragePercentSQLServer.resize();
        self.chartSqlserverProcessMemoryPercentSQLServer.resize();
        self.chartConnectionSuccessfulSQLServer.resize();
      });
    } else if (this.$route.query.accountTypeName == "GCP") {
      this.isGCP = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartSqlDiskReadOPS.resize();
        self.chartSqlDiskWriteOPS.resize();
        self.chartSqlCpuUsage.resize();
        self.chartSqlCpuUtilization.resize();
        self.chartDiskUtilization.resize();
        self.chartSqlMemoryUtilization.resize();
        self.chartSqlReceivedBytes.resize();
        self.chartNetworkConnections.resize();
        self.chartMemoryTotalUsage.resize();
        self.chartInnodbPagesTotal.resize();
      });
    }
  },
  created() {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.checkMonitorModuleIndex();
    } else if (this.$route.query.accountTypeName == "Aliyun") {
      this.isALY = true;
      this.checkMonitorModuleIndexAliyun();
    } else if (
      this.$route.query.accountTypeName == "Azure" &&
      this.$route.query.engine.indexOf("mysql") != -1
    ) {
      this.isAzureMySQL = true;
      this.checkAzureCloudDBforMySQLStatistics();
    } else if (
      this.$route.query.accountTypeName == "Azure" &&
      this.$route.query.engine.indexOf("SQL Server") != -1
    ) {
      this.isAzureSQLServer = true;
      this.checkAzureCloudSQLServerStatistics();
    } else if (this.$route.query.accountTypeName == "GCP") {
      this.isGCP = true;
      this.checkGcpCloudSQLIndex();
    }
  },
  methods: {
    /******************放大********************************/
    changeFull: function (item) {
      this.isShowModal = true;
      this.lineTitle = item.title;
      this.$nextTick(() => {
        const chartFul = this.$refs.fullChart;
        if (chartFul) {
          const fullChart = this.$echarts.init(
            document.getElementById("chart-part")
          );
          fullChart.clear();
          // AWS
          if (item.id == "cpu") {
            var optionFll = this.cpuOption;
          } else if (item.id == "databaseConnections") {
            var optionFll = this.databaseConnectionsOption;
          } else if (item.id == "cpucreditBalance") {
            var optionFll = this.cpucreditBalanceOption;
          } else if (item.id == "cpucreditUsage") {
            var optionFll = this.cpucreditUsageOption;
          } else if (item.id == "ebsbyteBalance") {
            var optionFll = this.ebsbyteBalanceOption;
          } else if (item.id == "ebsiobalance") {
            var optionFll = this.ebsiobalanceOption;
          } else if (item.id == "writeReadLatency") {
            var optionFll = this.writeReadLatencyOption;
          } else if (item.id == "networkReceiveTransmitThrough") {
            var optionFll = this.networkReceiveTransmitThroughOption;
          }else if (item.id == "bufferCacheHitRatio") {
            var optionFll = this.bufferCacheHitRatioOption;
          } else if (item.id == "freeStorage") {
            var optionFll = this.freeStorageOption;
          } else if (item.id == "availableMemory") {
            var optionFll = this.availableMemoryOption;
          } else if (item.id == "writeReadIOPS") {
            var optionFll = this.writeReadIOPSOption;
          } else if (item.id == "queueDepth") {
            var optionFll = this.queueDepthOption;
          } else if (item.id == "binaryLogDiskUsage") {
            var optionFll = this.binaryLogDiskUsageOption;
          } else if (item.id == "writeReadThroughput") {
            var optionFll = this.writeReadThroughputOption;
          } else if (item.id == "rdsReplicaLag") {
            var optionFll = this.rdsReplicaLagOption;
          }
          // 阿里云
          else if (item.id == "cpus") {
            var optionFll = this.cpusOption;
          } else if (item.id == "connectionUsages") {
            var optionFll = this.connectionUsagesOption;
          } else if (item.id == "memory") {
            var optionFll = this.memoryOption;
          } else if (item.id == "disk") {
            var optionFll = this.diskOption;
          } else if (item.id == "writeReadIOPSs") {
            var optionFll = this.writeReadIOPSsOption;
          } else if (item.id == "networkInput") {
            var optionFll = this.networkInputOption;
          } else if (item.id == "networkOut") {
            var optionFll = this.networkOutOption;
          } else if (item.id == "pgActiveConnections") {
            var optionFll = this.pgActiveConnectionsOption;
          } else if (item.id == "pgBlksReadDelta") {
            var optionFll = this.pgBlksReadDeltaOption;
          } else if (item.id == "pgConnUsage") {
            var optionFll = this.pgConnUsageOption;
          } else if (item.id == "pgCpuTotal") {
            var optionFll = this.pgCpuTotalOption;
          } else if (item.id == "pgDbAge") {
            var optionFll = this.pgDbAgeOption;
          } else if (item.id == "pgMemUsage") {
            var optionFll = this.pgMemUsageOption;
          } else if (item.id == "pgPlsDataSize") {
            var optionFll = this.pgPlsDataSizeOption;
          } else if (item.id == "pgPlsIops") {
            var optionFll = this.pgPlsIopsOption;
          } else if (item.id == "pgPlsIopsRead") {
            var optionFll = this.pgPlsIopsReadOption;
          } else if (item.id == "pgPlsIopsWrite") {
            var optionFll = this.pgPlsIopsWriteOption;
          } else if (item.id == "pgPlsPgWalDirSize") {
            var optionFll = this.pgPlsPgWalDirSizeOption;
          } else if (item.id == "pgPlsThroughput") {
            var optionFll = this.pgPlsThroughputOption;
          } else if (item.id == "pgPlsThroughputRead") {
            var optionFll = this.pgPlsThroughputReadOption;
          } else if (item.id == "pgPlsThroughputWrite") {
            var optionFll = this.pgPlsThroughputWriteOption;
          } else if (item.id == "pgRollbackRatio") {
            var optionFll = this.pgRollbackRatioOption;
          } else if (item.id == "pgSwellTime") {
            var optionFll = this.pgSwellTimeOption;
          } else if (item.id == "pgTps") {
            var optionFll = this.pgTpsOption;
          }

          // azureMySQL
          else if (item.id == "cpuPercentMySQL") {
            var optionFll = this.cpuPercentMySQLOption;
          } else if (item.id == "storagePercentMySQL") {
            var optionFll = this.storagePercentMySQLOption;
          } else if (item.id == "memoryPercentMySQL") {
            var optionFll = this.memoryPercentMySQLOption;
          } else if (item.id == "activeConnectionsMySQL") {
            var optionFll = this.activeConnectionsMySQLOption;
          } else if (item.id == "ioConsumptionPercentMySQL") {
            var optionFll = this.ioConsumptionPercentMySQLOption;
          }
          // azureSQLServer
          else if (item.id == "cpuPercentSQLServer") {
            var optionFll = this.cpuPercentSQLServerOption;
          } else if (item.id == "storagePercentSQLServer") {
            var optionFll = this.storagePercentSQLServerOption;
          } else if (item.id == "sqlserverProcessMemoryPercentSQLServer") {
            var optionFll = this.sqlserverProcessMemoryPercentSQLServerOption;
          } else if (item.id == "connectionSuccessfulSQLServer") {
            var optionFll = this.connectionSuccessfulSQLServerOption;
          }
          //gcp
          else if (item.id == "sqlDiskReadOPS") {
            var optionFll = this.sqlDiskReadOPSOption;
          } else if (item.id == "sqlDiskWriteOPS") {
            var optionFll = this.sqlDiskWriteOPSOption;
          } else if (item.id == "sqlCpuUsage") {
            var optionFll = this.sqlCpuUsageOption;
          } else if (item.id == "sqlCpuUtilization") {
            var optionFll = this.sqlCpuUtilizationOption;
          } else if (item.id == "diskUtilization") {
            var optionFll = this.diskUtilizationOption;
          } else if (item.id == "sqlMemoryUtilization") {
            var optionFll = this.sqlMemoryUtilizationOption;
          } else if (item.id == "sqlReceivedBytes") {
            var optionFll = this.sqlReceivedBytesOption;
          } else if (item.id == "networkConnections") {
            var optionFll = this.networkConnectionsOption;
          } else if (item.id == "memoryTotalUsage") {
            var optionFll = this.memoryTotalUsageOption;
          } else if (item.id == "innodbPagesTotal") {
            var optionFll = this.innodbPagesTotalOption;
          }

          fullChart.setOption(optionFll);
          window.addEventListener("resize", function () {
            fullChart.resize();
          });
        }
      });
    },
    // 模态框取消事件
    cancel() {
      this.isShowModal = false;
    },
    /******************查询********************************/
    // 查询时间范围
    queryTimeHorizon: function () {
      this.$api.cloudWatch
        .queryTimeHorizon("userName", getCookie(global.cookieName))
        .then((res) => {
          this.timeList = res.data;
        });
    },
    // Aws折线图
    checkMonitorModuleIndex: function () {
      var data = {
        accountId: this.$route.query.accountId,
        timeHorizon: this.timeType,
        monitorModule: 1,
        instanceId: this.$route.query.databaseId,
        region: this.$route.query.region,
      };
      this.$api.cloudWatch.checkMonitorModuleIndex(data).then((res) => {
        this.binLogDiskUsage = res.data.binLogDiskUsage;
        this.rdscpu = res.data.rdscpu;
        this.databaseConnections = res.data.databaseConnections;
        this.cpucreditBalance = res.data.cpucreditBalance;
        this.cpucreditUsage = res.data.cpucreditUsage;
        this.ebsbyteBalance = res.data.ebsbyteBalance;
        this.ebsiobalance = res.data.ebsiobalance;
        this.networkReceiveThroughput = res.data.networkReceiveThroughput;
        this.networkTransmitThroughput = res.data.networkTransmitThroughput;
        this.readLatency = res.data.readLatency;
        this.writeLatency = res.data.writeLatency;
        this.bufferCacheHitRatio = res.data.bufferCacheHitRatio;
        this.diskQueueDepth = res.data.diskQueueDepth;
        this.rdsdiskMonitorNative = res.data.rdsdiskMonitorNative;
        this.rdsramMonitorNative = res.data.rdsramMonitorNative;
        this.rdsreadWriteIOPS = res.data.rdsreadWriteIOPS;
        this.rdswriteIOPS = res.data.rdswriteIOPS;
        this.readThroughput = res.data.readThroughput;
        this.writeThroughput = res.data.writeThroughput;
        this.xaxisData = res.data.xaxisData;
        this.rdsReplicaLag = res.data.rdsReplicaLag;
        this.init();
      });
    },

    //阿里云折线图
    checkMonitorModuleIndexAliyun: function () {
      console.log("accountId", this.$route.query);
      var data = {
        accountId: this.$route.query.accountId,
        timeHorizon: this.timeType,
        monitorModule: 1,
        instanceId: this.$route.query.databaseId,
        region: this.$route.query.region,
        product: this.$route.query.product,
      };
      this.$api.cloudWatch.checkMonitorModuleIndex(data).then((res) => {
        this.xaxisData = res.data.xaxisData;
        this.cpuUsage = res.data.cpuUsage;
        this.memoryUsage = res.data.memoryUsage;
        this.diskUsage = res.data.diskUsage;
        this.iopsUsage = res.data.iopsUsage;
        this.connectionUsage = res.data.connectionUsage;
        this.networkInput = res.data.networkInput;
        this.networkOut = res.data.networkOut;
        this.pgActiveConnections = res.data.pgActiveConnections;
        this.pgBlksReadDelta = res.data.pgBlksReadDelta;
        this.pgConnUsage = res.data.pgConnUsage;
        this.pgCpuTotal = res.data.pgCpuTotal;
        this.pgDbAge = res.data.pgDbAge;
        this.pgMemUsage = res.data.pgMemUsage;
        this.pgPlsDataSize = res.data.pgPlsDataSize;
        this.pgPlsIops = res.data.pgPlsIops;
        this.pgPlsIopsRead = res.data.pgPlsIopsRead;
        this.pgPlsIopsWrite = res.data.pgPlsIopsWrite;
        this.pgPlsPgWalDirSize = res.data.pgPlsPgWalDirSize;
        this.pgPlsThroughput = res.data.pgPlsThroughput;
        this.pgPlsThroughputRead = res.data.pgPlsThroughputRead;
        this.pgPlsThroughputWrite = res.data.pgPlsThroughputWrite;
        this.pgRollbackRatio = res.data.pgRollbackRatio;
        this.pgSwellTime = res.data.pgSwellTime;
        this.pgTps = res.data.pgTps;
        this.rdsReplicaLag = res.data.rdsReplicaLag;
        this.aliMySQL();
      });
    },
    // Azure MySQL折线图
    checkAzureCloudDBforMySQLStatistics: function () {
      this.$api.cloudWatch
        .checkAzureCloudDBforMySQLStatistics({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          monitorModule: 18,
          instanceId: this.$route.query.databaseId,
          region: this.$route.query.region,
        })
        .then((res) => {
          // Azure
          this.azureCpuPercent = res.data.cpuPercent;
          this.azureStoragePercent = res.data.storagePercent;
          this.azureMemoryPercent = res.data.memoryPercent;
          this.azureActiveConnections = res.data.activeConnections;
          this.azureIoConsumptionPercent = res.data.ioConsumptionPercent;
          this.azureXaxisData = res.data.xaxisData;
          this.allMySQL();
        });
    },
    // Azure SqlServer折线图
    checkAzureCloudSQLServerStatistics: function () {
      this.$api.cloudWatch
        .checkAzureCloudSQLServerStatistics({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          monitorModule: 19,
          instanceId: this.$route.query.databaseId,
          region: this.$route.query.region,
        })
        .then((res) => {
          // Azure
          this.azureCpuPercentSqlServer = res.data.cpuPercent;
          this.azureStoragePercentSqlServer = res.data.storagePercent;
          this.azureSqlserverProcessMemoryPercentSqlServer =
            res.data.sqlserverProcessMemoryPercent;
          this.azureConnectionSuccessfulSqlServer =
            res.data.connectionSuccessful;
          this.azureXaxisDataSqlServer = res.data.xaxisData;
          this.allSqlServer();
        });
    },
    //GCP折线图
    checkGcpCloudSQLIndex: function () {
      this.$api.cloudWatch
        .checkGcpCloudSQLIndex({
          accountId: this.$route.query.accountId,
          instanceId: this.$route.query.instanceId,
          monitorModule: 1,
          timeHorizon: this.timeType,
        })
        .then((res) => {
          this.sqlDiskReadOPS = res.data.sqlDiskReadOPS;
          this.sqlDiskWriteOPS = res.data.sqlDiskWriteOPS;
          this.sqlCpuUsage = res.data.sqlCpuUsage;
          this.sqlCpuUtilization = res.data.sqlCpuUtilization;
          this.diskUtilization = res.data.diskUtilization;
          this.sqlMemoryUtilization = res.data.sqlMemoryUtilization;
          this.sqlReceivedBytes = res.data.sqlReceivedBytes;
          this.networkConnections = res.data.networkConnections;
          this.memoryTotalUsage = res.data.memoryTotalUsage;
          this.innodbPagesTotal = res.data.innodbPagesTotal;
          this.xaxisData = res.data.xaxisData;
          this.allGcp();
        });
    },
    // 切换周期
    changeCycle: function () {
      this.checkMonitorModuleIndex();
    },
    // 切换时间
    changeTimeType: function () {
      this.checkMonitorModuleIndex();
    },
    changeTimeTypeAzureMySQL: function () {
      this.checkAzureCloudDBforMySQLStatistics();
    },
    changeTimeTypeAzureSqlServer: function () {
      this.checkAzureCloudSQLServerStatistics();
    },
    //切换ALiyun时间
    changeTimeTypeALY: function () {
      this.checkMonitorModuleIndexAliyun();
    },
    //切换ALiyun周期
    changeCycleAliyun: function () {
      this.checkMonitorModuleIndexAliyun();
    },
    //切换GCP时间
    changeTimeTypeGCP: function () {
      this.checkGcpCloudSQLIndex();
    },
    //切换GCP周期
    changeCycleGCP: function () {
      this.checkGcpCloudSQLIndex();
    },
    /******************AWS 所有折线图********************************/
    init: function () {
      this.cpusLine();
      this.chartDatabaseConnectionsLine();
      this.chartCpucreditBalanceLine();
      this.chartCpucreditUsageLine();
      this.chartEbsbyteBalanceLine();
      this.chartEbsiobalanceLine();
      this.chartBufferCacheHitRatioLine();
      this.chartFreeStorageLine();
      this.chartAvailableMemoryLine();
      this.chartWriteReadLatencyLine();
      this.chartNetworkReceiveTransmitThroughLine();
      this.chartWriteReadIOPSLine();
      this.chartQueueDepthyLine();
      this.chartBinaryLogDiskUsageLine();
      this.chartWriteReadThroughputLine();
      this.chartRdsReplicaLagLine();
    },
    aliMySQL: function () {
      this.cpuLine();
      this.chartConnectionUsageLine();
      this.memoryLine();
      this.diskLine();
      this.chartWriteReadIOPSsLine();
      this.networkInputLine();
      this.networkOutLine();
      this.pgActiveConnectionsLine();
      this.pgBlksReadDeltaLine();
      this.pgConnUsageLine();
      this.pgCpuTotalLine();
      this.pgDbAgeLine();
      this.pgMemUsageLine();
      this.pgPlsDataSizeLine();
      this.pgPlsIopsLine();
      this.pgPlsIopsReadLine();
      this.pgPlsIopsWriteLine();
      this.pgPlsPgWalDirSizeLine();
      this.pgPlsThroughputLine();
      this.pgPlsThroughputReadLine();
      this.pgPlsThroughputWriteLine();
      this.pgRollbackRatioLine();
      this.pgSwellTimeLine();
      this.pgTpsLine();
    },
    allMySQL: function () {
      this.cpuPercentMySQLLine();
      this.storagePercentMySQLLine();
      this.memoryPercentMySQLLine();
      this.chartActiveConnectionsMySQLLine();
      this.chartIoConsumptionPercentMySQLLine();
    },
    allSqlServer: function () {
      this.cpuPercentSQLServerLine();
      this.storagePercentSQLServerLine();
      this.sqlserverProcessMemoryPercentSQLServerLine();
      this.connectionSuccessfulSQLServerLine();
    },
    allGcp: function () {
      this.sqlDiskReadOPSLine();
      this.sqlDiskWriteOPSLine();
      this.sqlCpuUsageLine();
      this.sqlCpuUtilizationLine();
      this.diskUtilizationLine();
      this.sqlMemoryUtilizationLine();
      this.sqlReceivedBytesLine();
      this.networkConnectionsLine();
      this.memoryTotalUsageLine();
      this.innodbPagesTotalLine();
    },
    // CPU 利用率 (百分比)
    cpusLine: function () {
      this.chart = this.$echarts.init(document.getElementById("cpu"));
      this.cpuOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // CPU利用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.CPUUtilization")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.CPUUtilization"),
            type: "line",
            data: this.rdscpu,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chart.setOption(this.cpuOption);
    },
    // 数据库连接数 (数量)
    chartDatabaseConnectionsLine: function () {
      this.chartDatabaseConnections = this.$echarts.init(
        document.getElementById("databaseConnections")
      );
      this.databaseConnectionsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 数据库连接数
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.NumberOfDatabaseConnections")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.NumberOfDatabaseConnections"),
            type: "line",
            data: this.databaseConnections,
            itemStyle: {
              normal: {
                color: "#c23531",
                lineStyle: {
                  color: "#c23531",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartDatabaseConnections.setOption(this.databaseConnectionsOption);
    },
    // CPU额度余额（Count）
    chartCpucreditBalanceLine: function () {
      this.chartCpucreditBalance = this.$echarts.init(
        document.getElementById("cpucreditBalance")
      );
      this.cpucreditBalanceOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // CPU额度余额
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.CpucreditBalance")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.CpucreditBalance"),
            type: "line",
            data: this.cpucreditBalance,
            itemStyle: {
              normal: {
                color: "#c23531",
                lineStyle: {
                  color: "#c23531",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartCpucreditBalance.setOption(this.cpucreditBalanceOption);
    },
    // CPU额度使用（Count）
    chartCpucreditUsageLine: function () {
      this.chartCpucreditUsage = this.$echarts.init(
        document.getElementById("cpucreditUsage")
      );
      this.cpucreditUsageOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // CPU额度使用
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.CpucreditUsage")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.CpucreditUsage"),
            type: "line",
            data: this.cpucreditUsage,
            itemStyle: {
              normal: {
                color: "#c23531",
                lineStyle: {
                  color: "#c23531",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartCpucreditUsage.setOption(this.cpucreditUsageOption);
    },
    // EBS 字节余额（百分比）
    chartEbsbyteBalanceLine: function () {
      this.chartEbsbyteBalance= this.$echarts.init(
        document.getElementById("ebsbyteBalance")
      );
      this.ebsbyteBalanceOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 字节余额
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.EbsbyteBalance")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.EbsbyteBalance"),
            type: "line",
            data: this.ebsbyteBalance,
            itemStyle: {
              normal: {
                color: "#c23531",
                lineStyle: {
                  color: "#c23531",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartEbsbyteBalance.setOption(this.ebsbyteBalanceOption);
    },
    // IO 余额 (数量)
    chartEbsiobalanceLine: function () {
      this.chartEbsiobalance = this.$echarts.init(
        document.getElementById("ebsiobalance")
      );
      this.ebsiobalanceOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // IO余额
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.EbsioBalancePercent")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.EbsioBalancePercent"),
            type: "line",
            data: this.ebsiobalance,
            itemStyle: {
              normal: {
                color: "#c23531",
                lineStyle: {
                  color: "#c23531",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartEbsiobalance.setOption(this.ebsiobalanceOption);
    },
    // 缓冲区缓存命中率（百分比）
    chartBufferCacheHitRatioLine: function () {
      this.chartBufferCacheHitRatio = this.$echarts.init(
        document.getElementById("bufferCacheHitRatio")
      );
      this.bufferCacheHitRatioOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 缓冲区缓存命中率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.BufferCacheHitRatioPercent")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.BufferCacheHitRatioPercent"),
            type: "line",
            data: this.bufferCacheHitRatio,
            itemStyle: {
              normal: {
                color: "#c23531",
                lineStyle: {
                  color: "#c23531",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartBufferCacheHitRatio.setOption(this.bufferCacheHitRatioOption);
    },
    // 可用存储空间 (字节)
    chartFreeStorageLine: function () {
      this.chartFreeStorage = this.$echarts.init(
        document.getElementById("freeStorage")
      );
      this.freeStorageOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 可用存储空间
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.AvailableStorageSpace")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.AvailableStorageSpace"),
            type: "line",
            data: this.rdsdiskMonitorNative,
            itemStyle: {
              normal: {
                color: "#61a0a8",
                lineStyle: {
                  color: "#61a0a8",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartFreeStorage.setOption(this.freeStorageOption);
    },
    // 可用内存 (MB)
    chartAvailableMemoryLine: function () {
      this.chartAvailableMemory = this.$echarts.init(
        document.getElementById("availableMemory")
      );
      this.availableMemoryOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 可用内存
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.AvailableMemory")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.AvailableMemory"),
            type: "line",
            data: this.rdsramMonitorNative,
            itemStyle: {
              normal: {
                color: "#ccc",
                lineStyle: {
                  color: "#ccc",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartAvailableMemory.setOption(this.availableMemoryOption);
    },
    // 读写 IOPS (次数/秒)
    chartWriteReadIOPSLine: function () {
      this.chartWriteReadIOPS = this.$echarts.init(
        document.getElementById("writeReadIOPS")
      );
      this.writeReadIOPSOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 读IOPS 写IOPS
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.database.line.ReadIOPS"),
            // this.$t("alarms.database.line.WriteIOPS"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.database.line.ReadIOPS"),
            type: "line",
            data: this.rdsreadWriteIOPS,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
          // {
          //   name: this.$t("alarms.database.line.WriteIOPS"),
          //   type: "line",
          //   data: this.rdswriteIOPS,
          //   itemStyle: {
          //     normal: {
          //       color: "#FF9B40",
          //       lineStyle: {
          //         color: "#FF9B40",
          //       },
          //     },
          //   },
          // },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartWriteReadIOPS.setOption(this.writeReadIOPSOption);
    },
    // 读写 延迟 (次数/秒)
    chartWriteReadLatencyLine: function () {
      this.chartWriteReadLatency = this.$echarts.init(
        document.getElementById("writeReadLatency")
      );
      this.writeReadLatencyOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 读写延迟
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.database.line.ReadLatencyMS"),
            this.$t("alarms.database.line.WriteLatencyMS"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.database.line.ReadLatencyMS"),
            type: "line",
            data: this.readLatency,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
          {
            name: this.$t("alarms.database.line.WriteLatencyMS"),
            type: "line",
            data: this.writeLatency,
            itemStyle: {
              normal: {
                color: "#FF9B40",
                lineStyle: {
                  color: "#FF9B40",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartWriteReadLatency.setOption(this.writeReadLatencyOption);
    },
    // 网络接收传输吞吐量 (次数/秒)
    chartNetworkReceiveTransmitThroughLine: function () {
      this.chartNetworkReceiveTransmitThrough = this.$echarts.init(
      document.getElementById("networkReceiveTransmitThrough")
      );
      this.networkReceiveTransmitThroughOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 网络接收传输吞吐量
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.database.line.NetworkReceiveThroughputMB"),
            this.$t("alarms.database.line.NetworkTransmitThroughputMB"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.database.line.NetworkReceiveThroughputMB"),
            type: "line",
            data: this.networkReceiveThroughput,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
          {
            name: this.$t("alarms.database.line.NetworkTransmitThroughputMB"),
            type: "line",
            data: this.networkTransmitThroughput,
            itemStyle: {
              normal: {
                color: "#FF9B40",
                lineStyle: {
                  color: "#FF9B40",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartNetworkReceiveTransmitThrough.setOption(this.networkReceiveTransmitThroughOption);
    },
    // 队列深度 (数量)
    chartQueueDepthyLine: function () {
      this.chartQueueDepth = this.$echarts.init(
        document.getElementById("queueDepth")
      );
      this.queueDepthOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 队列深度
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.QueueDepth")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.QueueDepth"),
            type: "line",
            data: this.diskQueueDepth,
            itemStyle: {
              normal: {
                color: "#bebebe",
                lineStyle: {
                  color: "#bebebe",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartQueueDepth.setOption(this.queueDepthOption);
    },
    // 二进制日志磁盘使用情况 (MB)
    chartBinaryLogDiskUsageLine: function () {
      this.chartBinaryLogDiskUsage = this.$echarts.init(
        document.getElementById("binaryLogDiskUsage")
      );
      this.binaryLogDiskUsageOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 二进制日志磁盘使用情况
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.BinaryLogDiskUsage")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.BinaryLogDiskUsage"),
            type: "line",
            data: this.binLogDiskUsage,
            itemStyle: {
              normal: {
                color: "#2ec7c9",
                lineStyle: {
                  color: "#2ec7c9",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartBinaryLogDiskUsage.setOption(this.binaryLogDiskUsageOption);
    },
    // 读写 吞吐量 (MB/秒)
    chartWriteReadThroughputLine: function () {
      this.chartWriteReadThroughput = this.$echarts.init(
        document.getElementById("writeReadThroughput")
      );
      this.writeReadThroughputOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 读吞吐量 写吞吐量
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.database.line.ReadThroughput"),
            this.$t("alarms.database.line.WriteThroughput"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.database.line.ReadThroughput"),
            type: "line",
            data: this.readThroughput,
            itemStyle: {
              normal: {
                color: "#a0a7e6",
                lineStyle: {
                  color: "#a0a7e6",
                },
              },
            },
          },
          {
            name: this.$t("alarms.database.line.WriteThroughput"),
            type: "line",
            data: this.writeThroughput,
            itemStyle: {
              normal: {
                color: "#f58db2",
                lineStyle: {
                  color: "#f58db2",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartWriteReadThroughput.setOption(this.writeReadThroughputOption);
    },
    // RDS只读副本ReplicaLag告警
    chartRdsReplicaLagLine: function () {
      this.chartRdsReplicaLag = this.$echarts.init(
        document.getElementById("rdsReplicaLag")
      );
      this.rdsReplicaLagOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // CPU利用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.rdsReadOnly")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.rdsReadOnly"),
            type: "line",
            data: this.rdsReplicaLag,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartRdsReplicaLag.setOption(this.rdsReplicaLagOption);
    },
    /*************************阿里云折线图*****************/
    // cpu使用率 (百分比)
    cpuLine: function () {
      this.chartCPU = this.$echarts.init(document.getElementById("cpus"));
      this.cpusOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // cpu使用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.CpuUsage")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.CpuUsage"),
            type: "line",
            data: this.cpuUsage,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartCPU.setOption(this.cpusOption);
    },
    // 连接数使用率 (百分比)
    chartConnectionUsageLine: function () {
      this.chartConnectionUsages = this.$echarts.init(
        document.getElementById("connectionUsages")
      );
      this.connectionUsagesOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.ConnectionUsageRate")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.ConnectionUsageRate"),
            type: "line",
            data: this.connectionUsage,
            itemStyle: {
              normal: {
                color: "#FF9B40",
                lineStyle: {
                  color: "#FF9B40",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartConnectionUsages.setOption(this.connectionUsagesOption);
    },
    // 内存使用率 (%)
    memoryLine: function () {
      this.chartMemory = this.$echarts.init(document.getElementById("memory"));
      this.memoryOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 内存使用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.MemoryUsage")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.MemoryUsage"),
            type: "line",
            data: this.memoryUsage,
            itemStyle: {
              normal: {
                color: "#c23531",
                lineStyle: {
                  color: "#c23531",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartMemory.setOption(this.memoryOption);
    },
    // 磁盘使用率 (%)
    diskLine: function () {
      this.chartDisk = this.$echarts.init(document.getElementById("disk"));
      this.diskOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 磁盘使用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.DiskUsage")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.DiskUsage"),
            type: "line",
            data: this.diskUsage,
            itemStyle: {
              normal: {
                color: "#61a0a8",
                lineStyle: {
                  color: "#61a0a8",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartDisk.setOption(this.diskOption);
    },
    //IOPS使用率 (%)
    chartWriteReadIOPSsLine: function () {
      this.chartWriteReadIOPS = this.$echarts.init(
        document.getElementById("writeReadIOPSs")
      );
      this.writeReadIOPSsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // IOPS使用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.IOPSUsageRate")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.IOPSUsageRate"),
            type: "line",
            data: this.iopsUsage,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartWriteReadIOPS.setOption(this.writeReadIOPSsOption);
    },
    //MYSQL网络入流量
    networkInputLine: function () {
      this.chartNetworkInput = this.$echarts.init(
        document.getElementById("networkInput")
      );
      this.networkInputOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.NetworkInput")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.NetworkInput"),
            type: "line",
            data: this.networkInput,
            itemStyle: {
              normal: {
                color: "#FFB5B5",
                lineStyle: {
                  color: "#FFB5B5",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartNetworkInput.setOption(this.networkInputOption);
    },

    //MYSQL网络出流量
    networkOutLine: function () {
      this.chartNetworkOut = this.$echarts.init(
        document.getElementById("networkOut")
      );
      this.networkOutOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.NetworkOut")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.NetworkOut"),
            type: "line",
            data: this.networkOut,
            itemStyle: {
              normal: {
                color: "#B9B9FF",
                lineStyle: {
                  color: "#B9B9FF",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartNetworkOut.setOption(this.networkOutOption);
    },

    //pg活跃连接数
    pgActiveConnectionsLine: function () {
      this.chartPgActiveConnections = this.$echarts.init(
        this.$refs.pgActiveConnections[0]
      );
      var arr = [];
      for (var i = 0; i < this.pgActiveConnections.length; i++) {
        var seriesA = {};
        seriesA.name = this.pgActiveConnections[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } },
        };
        seriesA.data = this.pgActiveConnections[i].pointData;
        arr.push(seriesA);
      }
      this.pgActiveConnectionsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [seriesA.name],
        },
        series: arr,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartPgActiveConnections.setOption(this.pgActiveConnectionsOption);
    },

    //pg数据块读取数
    pgBlksReadDeltaLine: function () {
      this.chartPgBlksReadDelta = this.$echarts.init(
        this.$refs.pgBlksReadDelta[0]
      );
      var arr = [];
      for (var i = 0; i < this.pgBlksReadDelta.length; i++) {
        var seriesA = {};
        seriesA.name = this.pgBlksReadDelta[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } },
        };
        seriesA.data = this.pgBlksReadDelta[i].pointData;
        arr.push(seriesA);
      }
      this.pgBlksReadDeltaOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [seriesA.name],
        },
        series: arr,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartPgBlksReadDelta.setOption(this.pgBlksReadDeltaOption);
    },

    //pg连接使用率
    pgConnUsageLine: function () {
      this.chartPgConnUsage = this.$echarts.init(this.$refs.pgConnUsage[0]);
      var arr = [];
      for (var i = 0; i < this.pgConnUsage.length; i++) {
        var seriesA = {};
        seriesA.name = this.pgConnUsage[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } },
        };
        seriesA.data = this.pgConnUsage[i].pointData;
        arr.push(seriesA);
      }
      this.pgConnUsageOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [seriesA.name],
        },
        series: arr,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartPgConnUsage.setOption(this.pgConnUsageOption);
    },

    //pgCPU使用率
    pgCpuTotalLine: function () {
      this.chartPgCpuTotal = this.$echarts.init(this.$refs.pgCpuTotal[0]);
      var arr = [];
      for (var i = 0; i < this.pgCpuTotal.length; i++) {
        var seriesA = {};
        seriesA.name = this.pgCpuTotal[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } },
        };
        seriesA.data = this.pgCpuTotal[i].pointData;
        arr.push(seriesA);
      }
      this.pgCpuTotalOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [seriesA.name],
        },
        series: arr,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartPgCpuTotal.setOption(this.pgCpuTotalOption);
    },

    //pg数据库未回卷xid数量
    pgDbAgeLine: function () {
      this.chartPgDbAge = this.$echarts.init(this.$refs.pgDbAge[0]);
      var arr = [];
      for (var i = 0; i < this.pgDbAge.length; i++) {
        var seriesA = {};
        seriesA.name = this.pgDbAge[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } },
        };
        seriesA.data = this.pgDbAge[i].pointData;
        arr.push(seriesA);
      }
      this.pgDbAgeOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [seriesA.name],
        },
        series: arr,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartPgDbAge.setOption(this.pgDbAgeOption);
    },

    //pg内存使用率
    pgMemUsageLine: function () {
      this.chartPgMemUsage = this.$echarts.init(this.$refs.pgMemUsage[0]);
      var arr = [];
      for (var i = 0; i < this.pgMemUsage.length; i++) {
        var seriesA = {};
        seriesA.name = this.pgMemUsage[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } },
        };
        seriesA.data = this.pgMemUsage[i].pointData;
        arr.push(seriesA);
      }
      this.pgMemUsageOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [seriesA.name],
        },
        series: arr,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartPgMemUsage.setOption(this.pgMemUsageOption);
    },
    //pg数据盘大小
    pgPlsDataSizeLine: function () {
      this.chartPgPlsDataSize = this.$echarts.init(this.$refs.pgPlsDataSize[0]);
      var arr = [];
      for (var i = 0; i < this.pgPlsDataSize.length; i++) {
        var seriesA = {};
        seriesA.name = this.pgPlsDataSize[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } },
        };
        seriesA.data = this.pgPlsDataSize[i].pointData;
        arr.push(seriesA);
      }
      this.pgPlsDataSizeOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [seriesA.name],
        },
        series: arr,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartPgPlsDataSize.setOption(this.pgPlsDataSizeOption);
    },

    //pgIOPS
    pgPlsIopsLine: function () {
      this.chartPgPlsIops = this.$echarts.init(this.$refs.pgPlsIops[0]);
      var arr = [];
      for (var i = 0; i < this.pgPlsIops.length; i++) {
        var seriesA = {};
        seriesA.name = this.pgPlsIops[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } },
        };
        seriesA.data = this.pgPlsIops[i].pointData;
        arr.push(seriesA);
      }
      this.pgPlsIopsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [seriesA.name],
        },
        series: arr,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartPgPlsIops.setOption(this.pgPlsIopsOption);
    },

    //pg读IOPS
    pgPlsIopsReadLine: function () {
      this.chartPgPlsIopsRead = this.$echarts.init(this.$refs.pgPlsIopsRead[0]);
      var arr = [];
      for (var i = 0; i < this.pgPlsIopsRead.length; i++) {
        var seriesA = {};
        seriesA.name = this.pgPlsIopsRead[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } },
        };
        seriesA.data = this.pgPlsIopsRead[i].pointData;
        arr.push(seriesA);
      }
      this.pgPlsIopsReadOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [seriesA.name],
        },
        series: arr,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartPgPlsIopsRead.setOption(this.pgPlsIopsReadOption);
    },

    //pg写IOPS
    pgPlsIopsWriteLine: function () {
      this.chartPgPlsIopsWrite = this.$echarts.init(
        this.$refs.pgPlsIopsWrite[0]
      );
      var arr = [];
      for (var i = 0; i < this.pgPlsIopsWrite.length; i++) {
        var seriesA = {};
        seriesA.name = this.pgPlsIopsWrite[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } },
        };
        seriesA.data = this.pgPlsIopsWrite[i].pointData;
        arr.push(seriesA);
      }
      this.pgPlsIopsWriteOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [seriesA.name],
        },
        series: arr,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartPgPlsIopsWrite.setOption(this.pgPlsIopsWriteOption);
    },

    //pgWAL日志大小(Mbyte)
    pgPlsPgWalDirSizeLine: function () {
      this.chartPgPlsPgWalDirSize = this.$echarts.init(
        this.$refs.pgPlsPgWalDirSize[0]
      );
      var arr = [];
      for (var i = 0; i < this.pgPlsPgWalDirSize.length; i++) {
        var seriesA = {};
        seriesA.name = this.pgPlsPgWalDirSize[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } },
        };
        seriesA.data = this.pgPlsPgWalDirSize[i].pointData;
        arr.push(seriesA);
      }
      this.pgPlsPgWalDirSizeOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [seriesA.name],
        },
        series: arr,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartPgPlsPgWalDirSize.setOption(this.pgPlsPgWalDirSizeOption);
    },

    //pgIO吞吐
    pgPlsThroughputLine: function () {
      this.chartPgPlsThroughput = this.$echarts.init(
        this.$refs.pgPlsThroughput[0]
      );
      var arr = [];
      for (var i = 0; i < this.pgPlsThroughput.length; i++) {
        var seriesA = {};
        seriesA.name = this.pgPlsThroughput[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } },
        };
        seriesA.data = this.pgPlsThroughput[i].pointData;
        arr.push(seriesA);
      }
      this.pgPlsThroughputOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [seriesA.name],
        },
        series: arr,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartPgPlsThroughput.setOption(this.pgPlsThroughputOption);
    },

    //pg读IO吞吐
    pgPlsThroughputReadLine: function () {
      this.chartPgPlsThroughputRead = this.$echarts.init(
        this.$refs.pgPlsThroughputRead[0]
      );
      var arr = [];
      for (var i = 0; i < this.pgPlsThroughputRead.length; i++) {
        var seriesA = {};
        seriesA.name = this.pgPlsThroughputRead[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } },
        };
        seriesA.data = this.pgPlsThroughputRead[i].pointData;
        arr.push(seriesA);
      }
      this.pgPlsThroughputReadOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [seriesA.name],
        },
        series: arr,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartPgPlsThroughputRead.setOption(this.pgPlsThroughputReadOption);
    },

    //pg写IO吞吐
    pgPlsThroughputWriteLine: function () {
      this.chartPgPlsThroughputWrite = this.$echarts.init(
        this.$refs.pgPlsThroughputWrite[0]
      );
      var arr = [];
      for (var i = 0; i < this.pgPlsThroughputWrite.length; i++) {
        var seriesA = {};
        seriesA.name = this.pgPlsThroughputWrite[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } },
        };
        seriesA.data = this.pgPlsThroughputWrite[i].pointData;
        arr.push(seriesA);
      }
      this.pgPlsThroughputWriteOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [seriesA.name],
        },
        series: arr,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartPgPlsThroughputWrite.setOption(this.pgPlsThroughputWriteOption);
    },

    //pg事务回滚率
    pgRollbackRatioLine: function () {
      this.chartPgRollbackRatio = this.$echarts.init(
        document.getElementById("pgRollbackRatio")
      );
      /*  this.chartPgRollbackRatio = this.$echarts.init(
        this.$refs.pgRollbackRatio[0]
      ); */
      /* var arr = [];
      for (var i = 0; i < this.pgRollbackRatio.length; i++) {
        var seriesA = {};
        seriesA.name = this.pgRollbackRatio[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } },
        };
        seriesA.data = this.pgRollbackRatio[i].pointData;
        arr.push(seriesA);
      } */
      this.pgRollbackRatioOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.PgRollbackRatio")],
          /*  data: [seriesA.name], */
        },
        /*  series: arr, */
        series: [
          {
            name: this.$t("alarms.database.line.PgRollbackRatio"),
            type: "line",
            data: this.pgRollbackRatio,
            itemStyle: {
              normal: {
                color: "#B9B9FF",
                lineStyle: {
                  color: "#B9B9FF",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartPgRollbackRatio.setOption(this.pgRollbackRatioOption);
    },

    //pg膨胀点
    pgSwellTimeLine: function () {
      this.chartPgSwellTime = this.$echarts.init(this.$refs.pgSwellTime[0]);
      var arr = [];
      for (var i = 0; i < this.pgSwellTime.length; i++) {
        var seriesA = {};
        seriesA.name = this.pgSwellTime[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } },
        };
        seriesA.data = this.pgSwellTime[i].pointData;
        arr.push(seriesA);
      }
      this.pgSwellTimeOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [seriesA.name],
        },
        series: arr,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartPgSwellTime.setOption(this.pgSwellTimeOption);
    },

    //pgTPS
    pgTpsLine: function () {
      this.chartPgTps = this.$echarts.init(this.$refs.pgTps[0]);
      var arr = [];
      for (var i = 0; i < this.pgTps.length; i++) {
        var seriesA = {};
        seriesA.name = this.pgTps[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } },
        };
        seriesA.data = this.pgTps[i].pointData;
        arr.push(seriesA);
      }
      this.pgTpsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 连接数使用率
        legend: {
          x: "right",
          y: "10px",
          data: [seriesA.name],
        },
        series: arr,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartPgTps.setOption(this.pgTpsOption);
    },
    /************************Azure mysql折线图*****************/
    // cpu使用率 (百分比)
    cpuPercentMySQLLine: function () {
      this.chartCpuPercentMySQL = this.$echarts.init(
        document.getElementById("cpuPercentMySQL")
      );
      this.cpuPercentMySQLOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // cpu使用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.CpuUsage")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.CpuUsage"),
            type: "line",
            data: this.azureCpuPercent,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.azureXaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartCpuPercentMySQL.setOption(this.cpuPercentMySQLOption);
    },
    // 存储利用率 (百分比)
    storagePercentMySQLLine: function () {
      this.chartStoragePercentMySQL = this.$echarts.init(
        document.getElementById("storagePercentMySQL")
      );
      this.storagePercentMySQLOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 存储利用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.StorageUtilization")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.StorageUtilization"),
            type: "line",
            data: this.azureStoragePercent,
            itemStyle: {
              normal: {
                color: "#FF9B40",
                lineStyle: {
                  color: "#FF9B40",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.azureXaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartStoragePercentMySQL.setOption(this.storagePercentMySQLOption);
    },
    // 内存利用率 (%)
    memoryPercentMySQLLine: function () {
      this.chartMemoryPercentMySQL = this.$echarts.init(
        document.getElementById("memoryPercentMySQL")
      );
      this.memoryPercentMySQLOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 内存利用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.MemoryUtilization")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.MemoryUtilization"),
            type: "line",
            data: this.azureMemoryPercent,
            itemStyle: {
              normal: {
                color: "#c23531",
                lineStyle: {
                  color: "#c23531",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.azureXaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartMemoryPercentMySQL.setOption(this.memoryPercentMySQLOption);
    },
    // 活动连接数 (Count)
    chartActiveConnectionsMySQLLine: function () {
      this.chartActiveConnectionsMySQL = this.$echarts.init(
        document.getElementById("activeConnectionsMySQL")
      );
      this.activeConnectionsMySQLOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 活动连接数
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.ActiveConnections")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.ActiveConnections"),
            type: "line",
            data: this.azureActiveConnections,
            itemStyle: {
              normal: {
                color: "#61a0a8",
                lineStyle: {
                  color: "#61a0a8",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.azureXaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartActiveConnectionsMySQL.setOption(
        this.activeConnectionsMySQLOption
      );
    },
    //IO利用率 (%)
    chartIoConsumptionPercentMySQLLine: function () {
      this.chartIoConsumptionPercentMySQL = this.$echarts.init(
        document.getElementById("ioConsumptionPercentMySQL")
      );
      this.ioConsumptionPercentMySQLOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // IO利用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.IOUtilization")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.IOUtilization"),
            type: "line",
            data: this.azureIoConsumptionPercent,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.azureXaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartIoConsumptionPercentMySQL.setOption(
        this.ioConsumptionPercentMySQLOption
      );
    },
    /************************Azure SqlServer折线图*****************/
    // CPU利用率 (百分比)
    cpuPercentSQLServerLine: function () {
      this.chartCpuPercentSQLServer = this.$echarts.init(
        document.getElementById("cpuPercentSQLServer")
      );
      this.cpuPercentSQLServerOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // CPU利用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.CPUUtilization")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.CPUUtilization"),
            type: "line",
            data: this.azureCpuPercentSqlServer,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.azureXaxisDataSqlServer.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartCpuPercentSQLServer.setOption(this.cpuPercentSQLServerOption);
    },
    // 存储利用率 (百分比)
    storagePercentSQLServerLine: function () {
      this.chartStoragePercentSQLServer = this.$echarts.init(
        document.getElementById("storagePercentSQLServer")
      );
      this.storagePercentSQLServerOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 存储利用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.StorageUtilization")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.StorageUtilization"),
            type: "line",
            data: this.azureStoragePercentSqlServer,
            itemStyle: {
              normal: {
                color: "#FF9B40",
                lineStyle: {
                  color: "#FF9B40",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.azureXaxisDataSqlServer.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartStoragePercentSQLServer.setOption(
        this.storagePercentSQLServerOption
      );
    },
    // 进程内存百分比 (%)
    sqlserverProcessMemoryPercentSQLServerLine: function () {
      this.chartSqlserverProcessMemoryPercentSQLServer = this.$echarts.init(
        document.getElementById("sqlserverProcessMemoryPercentSQLServer")
      );
      this.sqlserverProcessMemoryPercentSQLServerOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 进程内存百分比
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.ProcessMemoryPercentage")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.ProcessMemoryPercentage"),
            type: "line",
            data: this.azureSqlserverProcessMemoryPercentSqlServer,
            itemStyle: {
              normal: {
                color: "#c23531",
                lineStyle: {
                  color: "#c23531",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.azureXaxisDataSqlServer.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartSqlserverProcessMemoryPercentSQLServer.setOption(
        this.sqlserverProcessMemoryPercentSQLServerOption
      );
    },
    // 成功连接数 (Count)
    connectionSuccessfulSQLServerLine: function () {
      this.chartConnectionSuccessfulSQLServer = this.$echarts.init(
        document.getElementById("connectionSuccessfulSQLServer")
      );
      this.connectionSuccessfulSQLServerOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 成功连接数
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.NumberOfSuccessfulConnections")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.NumberOfSuccessfulConnections"),
            type: "line",
            data: this.azureConnectionSuccessfulSqlServer,
            itemStyle: {
              normal: {
                color: "#61a0a8",
                lineStyle: {
                  color: "#61a0a8",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.azureXaxisDataSqlServer.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartConnectionSuccessfulSQLServer.setOption(
        this.connectionSuccessfulSQLServerOption
      );
    },
    /*************GCP折线图*****************************/
    //磁盘读取IO
    sqlDiskReadOPSLine: function () {
      this.chartSqlDiskReadOPS = this.$echarts.init(
        document.getElementById("sqlDiskReadOPS")
      );
      this.sqlDiskReadOPSOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.SqlDiskReadOPS")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.SqlDiskReadOPS"),
            type: "line",
            data: this.sqlDiskReadOPS,
            itemStyle: {
              normal: {
                color: "#B9B9FF",
                lineStyle: {
                  color: "#B9B9FF",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartSqlDiskReadOPS.setOption(this.sqlDiskReadOPSOption);
    },

    //磁盘写入IO
    sqlDiskWriteOPSLine: function () {
      this.chartSqlDiskWriteOPS = this.$echarts.init(
        document.getElementById("sqlDiskWriteOPS")
      );
      this.sqlDiskWriteOPSOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.SqlDiskWriteOPS")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.SqlDiskWriteOPS"),
            type: "line",
            data: this.sqlDiskWriteOPS,
            itemStyle: {
              normal: {
                color: "#B9B9FF",
                lineStyle: {
                  color: "#B9B9FF",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartSqlDiskWriteOPS.setOption(this.sqlDiskWriteOPSOption);
    },

    //累计使用时间
    sqlCpuUsageLine: function () {
      this.chartSqlCpuUsage = this.$echarts.init(
        document.getElementById("sqlCpuUsage")
      );
      this.sqlCpuUsageOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.SqlCpuUsage")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.SqlCpuUsage"),
            type: "line",
            data: this.sqlCpuUsage,
            itemStyle: {
              normal: {
                color: "#B9B9FF",
                lineStyle: {
                  color: "#B9B9FF",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartSqlCpuUsage.setOption(this.sqlCpuUsageOption);
    },
    //CPU利用率
    sqlCpuUtilizationLine: function () {
      this.chartSqlCpuUtilization = this.$echarts.init(
        document.getElementById("sqlCpuUtilization")
      );
      this.sqlCpuUtilizationOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.SqlCpuUtilization")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.SqlCpuUtilization"),
            type: "line",
            data: this.sqlCpuUtilization,
            itemStyle: {
              normal: {
                color: "#B9B9FF",
                lineStyle: {
                  color: "#B9B9FF",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartSqlCpuUtilization.setOption(this.sqlCpuUtilizationOption);
    },
    //磁盘利用率
    diskUtilizationLine: function () {
      this.chartDiskUtilization = this.$echarts.init(
        document.getElementById("diskUtilization")
      );
      this.diskUtilizationOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.DiskUtilization")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.DiskUtilization"),
            type: "line",
            data: this.diskUtilization,
            itemStyle: {
              normal: {
                color: "#B9B9FF",
                lineStyle: {
                  color: "#B9B9FF",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartDiskUtilization.setOption(this.diskUtilizationOption);
    },

    //内存利用率
    sqlMemoryUtilizationLine: function () {
      this.chartSqlMemoryUtilization = this.$echarts.init(
        document.getElementById("sqlMemoryUtilization")
      );
      this.sqlMemoryUtilizationOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.SqlMemoryUtilization")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.SqlMemoryUtilization"),
            type: "line",
            data: this.sqlMemoryUtilization,
            itemStyle: {
              normal: {
                color: "#B9B9FF",
                lineStyle: {
                  color: "#B9B9FF",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartSqlMemoryUtilization.setOption(this.sqlMemoryUtilizationOption);
    },

    //网络字节数
    sqlReceivedBytesLine: function () {
      this.chartSqlReceivedBytes = this.$echarts.init(
        document.getElementById("sqlReceivedBytes")
      );
      this.sqlReceivedBytesOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.SqlReceivedBytes")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.SqlReceivedBytes"),
            type: "line",
            data: this.sqlReceivedBytes,
            itemStyle: {
              normal: {
                color: "#B9B9FF",
                lineStyle: {
                  color: "#B9B9FF",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartSqlReceivedBytes.setOption(this.sqlReceivedBytesOption);
    },

    //数据库连接数
    networkConnectionsLine: function () {
      this.chartNetworkConnections = this.$echarts.init(
        document.getElementById("networkConnections")
      );
      this.networkConnectionsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.NetworkConnections")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.NetworkConnections"),
            type: "line",
            data: this.networkConnections,
            itemStyle: {
              normal: {
                color: "#B9B9FF",
                lineStyle: {
                  color: "#B9B9FF",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartNetworkConnections.setOption(this.networkConnectionsOption);
    },

    //总页数
    innodbPagesTotalLine: function () {
      this.chartInnodbPagesTotal = this.$echarts.init(
        document.getElementById("innodbPagesTotal")
      );
      this.innodbPagesTotalOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.InnodbPagesTotal")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.InnodbPagesTotal"),
            type: "line",
            data: this.innodbPagesTotal,
            itemStyle: {
              normal: {
                color: "#B9B9FF",
                lineStyle: {
                  color: "#B9B9FF",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInnodbPagesTotal.setOption(this.innodbPagesTotalOption);
    },
    //总内存使用量
    memoryTotalUsageLine: function () {
      this.chartMemoryTotalUsage = this.$echarts.init(
        document.getElementById("memoryTotalUsage")
      );
      this.memoryTotalUsageOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.database.line.MemoryTotalUsageInnoDB")],
        },
        series: [
          {
            name: this.$t("alarms.database.line.MemoryTotalUsageInnoDB"),
            type: "line",
            data: this.memoryTotalUsage,
            itemStyle: {
              normal: {
                color: "#B9B9FF",
                lineStyle: {
                  color: "#B9B9FF",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartMemoryTotalUsage.setOption(this.memoryTotalUsageOption);
    },

    /********************************/
    // 点击返回详情页
    ipAddress: function () {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.databaseId = this.$route.query.databaseId;
      this.region = this.$route.query.region;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.accountName = this.$route.query.accountName;
      this.name = this.$route.query.name;
      this.engine = this.$route.query.engine;
      this.$router.push({
        path: "/monitor/relationalDatabaseServiceDetail/",
        query: {
          id: this.id,
          accountId: this.accountId,
          databaseId: this.databaseId,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name,
          engine: this.engine,
        },
      });
    },
  },
};
</script>

<style scoped>
.rds-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-col-span-6 {
  margin-bottom: 20px;
}
.rds-top {
  width: 100%;
  height: 53px;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>





// WEBPACK FOOTER //
// src/components/monitor/rds/rds_dashboard/RDS.vue